import { render, staticRenderFns } from "./humanTranslation.vue?vue&type=template&id=21004e62&scoped=true"
import script from "./humanTranslation.vue?vue&type=script&lang=js"
export * from "./humanTranslation.vue?vue&type=script&lang=js"
import style0 from "./humanTranslation.vue?vue&type=style&index=0&id=21004e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21004e62",
  null
  
)

export default component.exports